import * as Yup from 'yup';

export type AppAdsSellerType = "DIRECT" | "RESELLER" | "EITHER";
export type DistributionScope = "public" | `seller:${string}` | `domain:${string}`;

export interface ILine {
  id: number;
  agencyId?: number;
  domain: string;
  domainId?: number;
  externalSellerId?: string;
  resellerDomain?: string;
  sellerType: AppAdsSellerType;
  scope?: DistributionScope;
  status?: "valid" | "invalid" | "deleted" | "pending" | "manual";
  tagId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const getLineSchema = (dspConstrained: boolean) => Yup.object().shape({
  domainId: Yup.number().required('Domain is required').nullable(),
  externalSellerId: Yup.string().required('Seller ID is required'),
  sellerType: Yup.string()
    .oneOf(
      dspConstrained ? ['DIRECT'] : ['RESELLER', 'EITHER'],
      'Seller type is not allowed for this agency'
    )
    .required('Seller type is required'),
  scope: Yup.string()
    .required('Scope is required')
    .test(
      'either-not-public',
      'Public scope is not allowed when seller type is EITHER',
      function (value) {
        return !(value === 'public' && this.parent.sellerType === 'EITHER');
      }
    )
    .test(
      'p2p-not-public',
      'Public scope is not allowed for this agency',
      (value) => !(value === 'public' && dspConstrained)
    ),
  scopeValue: Yup.string().when('scope', {
    is: (value) => value === 'seller' || value === 'domain',
    then: () => Yup.string().required('Scope value is required'),
    otherwise: () => Yup.string()
  }),
  status: Yup.string().required('Status is required'),
  resellerDomain: Yup.string().nullable()
});
